import { computed, action, observable } from 'mobx';
import EventTicketPurchases from 'app/dataStores/eventTicketPurchases';
import CouponPurchases from 'app/dataStores/couponPurchases';
import TicketBaseViewStore from '../common/view';

class TicketsBaseViewStore extends TicketBaseViewStore {
  constructor() {
    super();
    this.setAvailable(
      this.activeObject.available < 0 ? 0 : this.activeObject.available
    );
    if (this.activeObject.type === 'event') {
      this.purchaseDataStore = new EventTicketPurchases(
        this.activeObject.facility
      );
    } else {
      this.purchaseDataStore = new CouponPurchases(this.activeObject.facility);
    }
    this.purchaseDataStore.setTicketId(this.activeObject.id);
  }
  purchaseDataStore;
  @observable accessor available;

  @computed get eventDate() {
    if (!this.activeObject) return;

    const begins = moment(this.activeObject.begins).format('L');

    return begins;
  }

  @computed get eventTime() {
    if (!this.activeObject) return;

    const begins = moment(this.activeObject.begins).format('HH:mm');
    const ends =
      this.activeObject.ends &&
      !moment(this.activeObject.ends).isSame(this.activeObject.begins) &&
      moment(this.activeObject.ends).format('HH:mm');

    return `${begins}${ends ? ' - ' + ends : ''}`;
  }

  @computed
  get timespan() {
    if (!this.activeObject) return;

    if (this.activeObject.type === 'event') {
      return i18n.sprintf(
        i18n.gettext('%s at %s'),
        this.eventDate,
        this.eventTime
      );
    } else {
      const begins = moment(this.activeObject.begins);
      const ends = moment(this.activeObject.ends);
      if (begins.isSame(ends, 'day')) {
        return i18n.sprintf(i18n.gettext('Valid on %s'), begins.format('L'));
      } else {
        return i18n.sprintf(
          i18n.gettext('Valid from %s to %s'),
          begins.format('L'),
          ends.format('L')
        );
      }
    }
  }

  @computed get minNumber() {
    return this.activeObject.min_purchases || 1;
  }

  @computed get maxNumber() {
    const { max_purchases: maxPurchases } = this.activeObject;
    return maxPurchases
      ? Math.min(maxPurchases, this.available)
      : this.available;
  }

  @action setAvailable(available) {
    this.available = available;
  }
}

export default new TicketsBaseViewStore();
